import client from './client';
import { IArticleResponse } from '@/types/api-responses';

export async function articles(from: number, count: number) {
    const { data } = await client.GET('/api/v1/public/articles', {
        params: { query: { from, count } }
    });
    return data as unknown as IArticleResponse[];
}

export async function article(id: number) {
    const { data } = await client.GET('/api/v1/public/articles/{id}', {
        params: { path: { id } }
    });
    return data as unknown as IArticleResponse;
}